import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideStore } from '@ngrx/store';
import { sessionReducer } from '../src/utilities/session/session.reducer'; // o el reducer que corresponda
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { SessionEffects } from './utilities/session/session.effects';
import { provideEffects } from '@ngrx/effects';
import { IonicModule } from '@ionic/angular';
import { AuthHttpInterceptor } from './utilities/api/auth-http-interceptor.service';
import { spinnerInterceptor } from './loading.interceptor';
import { sessionInterceptor } from './utilities/interceptors/session.interceptor';
import { UtilsService } from './shared/utils.service';
import { L10N_CONFIG, L10nTranslationService } from 'angular-l10n';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// Importar iconos de Ionicons
import { addIcons } from 'ionicons';
import {
  mail,
  key,
  eyeOutline,
  eyeOffOutline,
  person,
  call,
  location,
  business,
  search,
  text,
  checkmark,
  contrast,
  eye,
  eyeOff,
  close,
  arrowBack,
  lockClosed,
  sunny,
  documentText,
  logOut,
  chevronForward,
  chevronBack,
  calendarOutline,
  timeOutline,
  sync,
  arrowForward,
  arrowUp,
  cubeOutline,
  searchOutline,
  // QR Scanner icons
  closeOutline,
  cameraOutline,
  flashOutline,
  flashOffOutline,
  flash,
  flashOff,
  qrCodeOutline,
  scanOutline,
  refreshOutline,
  alertCircle,
  alertCircleOutline,
  sunnyOutline,
  downloadOutline,
  barcodeOutline,
  // Add Packaging icons
  informationCircle,
  locationOutline,
  trashOutline,
  layersOutline,
  businessOutline,
  checkmarkCircleOutline,
  // Modal icons
  checkmarkCircle,
  closeCircle,
  warning,
  warningOutline,
  informationCircleOutline,
  helpCircle,
  // Collect Packaging icons
  gitBranchOutline,
  shieldCheckmarkOutline,
  listOutline,
  cube,
  homeOutline,
  chevronDownOutline,
  chevronUpOutline,
  hourglassOutline,
  timerOutline,
  timeSharp,
  barbellOutline,
  checkmarkOutline,
  leafOutline,
  carOutline,
  // Weigh Packaging icons
  scaleOutline,
  hardwareChipOutline,
  createOutline,
  repeatOutline,
  returnDownBackOutline,
  ellipse,
  checkmarkDoneOutline,
  bluetooth,
  bluetoothOutline,
  radioOutline,
  pulseOutline,
  wifiOutline,
  cellularOutline,
  readerOutline,
  arrowBackOutline,
  fileTrayStackedOutline,
  fileTrayStacked
} from 'ionicons/icons';

// Registrar iconos globalmente
addIcons({
  mail,
  key,
  eyeOutline,
  eyeOffOutline,
  person,
  call,
  location,
  business,
  search,
  text,
  checkmark,
  contrast,
  eye,
  eyeOff,
  close,
  arrowBack,
  lockClosed,
  sunny,
  documentText,
  logOut,
  chevronForward,
  chevronBack,
  calendarOutline,
  timeOutline,
  sync,
  arrowForward,
  arrowUp,
  cubeOutline,
  searchOutline,
  // QR Scanner icons
  closeOutline,
  cameraOutline,
  flashOutline,
  flashOffOutline,
  flash,
  flashOff,
  qrCodeOutline,
  scanOutline,
  refreshOutline,
  alertCircle,
  alertCircleOutline,
  sunnyOutline,
  downloadOutline,
  barcodeOutline,
  // Add Packaging icons
  informationCircle,
  locationOutline,
  trashOutline,
  layersOutline,
  businessOutline,
  checkmarkCircleOutline,
  // Modal icons
  checkmarkCircle,
  closeCircle,
  warning,
  warningOutline,
  informationCircleOutline,
  helpCircle,
  // Collect Packaging icons
  gitBranchOutline,
  shieldCheckmarkOutline,
  listOutline,
  cube,
  homeOutline,
  chevronDownOutline,
  chevronUpOutline,
  hourglassOutline,
  timerOutline,
  timeSharp,
  barbellOutline,
  checkmarkOutline,
  leafOutline,
  carOutline,
  // Weigh Packaging icons
  scaleOutline,
  hardwareChipOutline,
  createOutline,
  repeatOutline,
  returnDownBackOutline,
  ellipse,
  checkmarkDoneOutline,
  bluetooth,
  bluetoothOutline,
  radioOutline,
  pulseOutline,
  wifiOutline,
  cellularOutline,
  readerOutline,
  arrowBackOutline,
  fileTrayStackedOutline,
  fileTrayStacked
});

// Registrar el locale español
registerLocaleData(localeEs, 'es');

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'es' },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom(FormsModule, ReactiveFormsModule),
    provideStore({ session: sessionReducer }),
    provideEffects([SessionEffects]),
    importProvidersFrom(
      IonicModule.forRoot({ mode: 'md' })  // Fuerza Material Design
    ),
    // Configurar HttpClient con todos los interceptores en orden correcto
    provideHttpClient(
      withInterceptors([sessionInterceptor, spinnerInterceptor])
    ),
    // AuthHttpInterceptor debe registrarse como HTTP_INTERCEPTORS ya que usa formato antiguo
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    UtilsService,

  ],
});
